import React, {
    createContext
} from 'react';

const EssityContext = createContext();
export default EssityContext;